import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { posiciones, reportePosiciones } from './../../../../../../../_entities/coordenadas/ReportePosiciones';
import { Component, Inject, OnInit } from '@angular/core';
import { MapaService } from './../../../../../../../views/monitoreo/services/mapa.service';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import { ReportesService } from './../../../../../../reportes/service/reportes.service';
import { ReporteVelocidad } from './../../../../../../../_entities/Reportes/ReporteVelocidad';

@Component({
	selector: 'kt-grafica-estadistica-vehiculo',
	templateUrl: './grafica-estadistica-vehiculo.component.html',
	styleUrls: ['./grafica-estadistica-vehiculo.component.scss']
})
export class GraficaEstadisticaVehiculoComponent implements OnInit {
	public lista: posiciones[];
	public vehiculoInfo;
	public fin;
	public canvasWidth = 300
	public centralLabel = ''
	public name;
	public options;
	public canvasWidth2 = 300
	public centralLabel2 = ''
	public name2;
	public options2;
	public graficaVelocidad = [];

	public fechaInicial;
	public fechaFinal;

	public final;
	public latini = 0.0;
	public lngini = 0.0;
	public latfin = 0.0;
	public lngfin = 0.0;
	public i = 0;
	public velocidad = 0;
	public val = 0;
	public minimoChar = 999999;
	public maximochar = 0;
	public totalDistance = 0.0;
	public operacion = 0.00;
	public promedio = 0.00;

	public loadingVisible: boolean = false;

	colorVelPromedio = {
		domain: ['#46be8a']
	};

	colorVelMax = {
		domain: ['#fb434a']
	};

	colorDistancia = {
		domain: ['#166ba2']
	};

	velPromedio = [];
	velMaxima = []
	multi = []
	viewVel: any[] = [400, 300];
	legendVel: boolean = true;
	legendPositionVel: string = 'below';

	viewLine: any[] = [500, 300];

	// options
	legend: boolean = true;
	showLabels: boolean = true;
	animations: boolean = true;
	xAxis: boolean = true;
	yAxis: boolean = true;
	showYAxisLabel: boolean = true;
	showXAxisLabel: boolean = true;
	//xAxisLabel: string = 'Year';
	//yAxisLabel: string = 'Population';
	timeline: boolean = true;
	public intervalo;
	public tituloRecorrido: string;
	gaugeUnits: string = 'km/h'

	constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<GraficaEstadisticaVehiculoComponent>,
		private mapaService: MapaService,
		private datepipe: DatePipe) {
		Object.assign(this.velPromedio);
		Object.assign(this.velMaxima);
		Object.assign(this.multi);
	}

	ngOnInit() {
		if (this.data !== null) {
			this.lista = this.data.posiciones;
			const len = this.data.posiciones.length - 1;
			this.vehiculoInfo = this.mapaService.datosGenerales

			this.fechaInicial = this.data.posiciones[0].fecha;
			this.fechaFinal = this.data.posiciones[len].fecha;

			this.totalDistance = this.data.totalDistancia;

			this.consultarCharts();
		} else {
			this.lista = JSON.parse(sessionStorage.getItem('historico'));

			const len = this.lista.length - 1;
			this.vehiculoInfo = this.mapaService.datosGenerales

			this.fechaInicial = this.lista[0].fecha;
			this.fechaFinal = this.lista[len].fecha;
			//this.obtenerReporteDistancia()

			this.consultarCharts();
		}


	}

	velocidades(arg: any) {
		return arg.valueText + " km/h";
	}

	distancia(arg: any) {
		return arg.valueText + " km";
	}

	/**Formulas  calculate distance No se usa actualmente*
	calculateDistance(lat1, lng1, lat2, lng2) {
		/*var p = 0.017453292519943295;
		var c = Math.cos;
		var a = 0.5 - c((lat2 - lat1) * p) / 2 +
			c(lat1 * p) * c(lat2 * p) *
			(1 - c((lon2 - lon1) * p)) / 2;
		return 6371 * Math.asin(Math.sqrt(a));*

		let distance = 0;
		let Lat = (lat2 - lat1) * (Math.PI / 180);
		let Lon = (lng2 - lng1) * (Math.PI / 180);
		let a = Math.sin(Lat / 2) * Math.sin(Lat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(Lon / 2) * Math.sin(Lon / 2);
		let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		distance = 6371 * c;
		return distance;
	}*/

	consultarCharts() {
		this.lista.forEach(element => {
			if (this.i == 0) {
				this.latini = element.lat;
				this.lngini = element.lng;
			}

			this.latfin = element.lat;
			this.lngfin = element.lng;

			this.intervalo = (this.totalDistance / 5);

			let velocidad = Number(element.velocidad.toString().replace(' Km/h', ''));


			if (velocidad > 0) {
				this.velocidad = this.velocidad + velocidad;
				const minimo = velocidad;
				const maximo = velocidad;

				this.val++;
				if (this.minimoChar > minimo) {
					this.minimoChar = minimo;
				}
				else if (this.maximochar < maximo) {
					this.maximochar = maximo;
				}
			}

			this.latini = this.latfin;
			this.lngini = this.lngfin;
			this.i++;
		})
		this.tituloRecorrido = 'Distancia Recorrida: ' + this.totalDistance.toFixed(2) + ' km'
		this.promedio = this.velocidad / this.val;
	}

	valueFormatting(value: number): string {
		//Retorna el valor redondeado con punto decimal de las graficas de velocidad
		return `${value.toFixed(2)}`;
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


	imprimirGrafica() {
		this.loadingVisible = true;

		const PLACA = this.validarInfo(this.vehiculoInfo.placas);
		const ECONOMICO = this.validarInfo(this.vehiculoInfo.economico);
		const SERIE = this.validarInfo(this.vehiculoInfo.numeroSerie);
		const MARCA = this.validarInfo(this.vehiculoInfo.marca);
		const MODELO = this.validarInfo(this.vehiculoInfo.modelo);
		const ANIO = this.validarInfo(this.vehiculoInfo.anio);
		const COLOR = this.validarInfo(this.vehiculoInfo.color);
		const DESCRIPCION = this.validarInfo(this.vehiculoInfo.descripcion);
		const FECHA_INICIAL = this.validarInfo(this.fechaInicial);
		const FECHA_FINAL = this.validarInfo(this.fechaFinal);
		let ignicion = this.vehiculoInfo.ignicion;
		let direccion = '';

		this.mapaService.getDireccion([this.vehiculoInfo.lng, this.vehiculoInfo.lat]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";
			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);

		if (ignicion === 0) {
			ignicion = "Apagado"
		} else if (this.data.ignicion === 1) {
			ignicion = "Encendido"
		}

		let velocidades = document.getElementById('velocidades');
		//var distanciaRecorrida = document.getElementById('recorrido');
		setTimeout(async () => {
			await html2canvas(velocidades).then(
				(canvas) => {
					const velocidadesImg = canvas.toDataURL('image/PNG');

					let pdf = new jsPDF('p', 'pt', 'a4');

					const logoGTM = './assets/media/logos/logo-gtm.png'
					const logoGTMX = 20;
					const logoGTMY = 15;
					const logoGTMWidth = 180;
					const logoGTMHeight = 80;

					pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

					pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

					const logoGTMWater = './assets/media/logos/marca-de-agua.png'
					const logoGTMWaterX = 15;
					const logoGTMWaterY = 130;
					const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
					const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
					const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
					pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

					pdf.setFontSize(18);
					pdf.setFont('', 'bold');

					pdf.text('Informacion Estadística del Dispositivo', 150, 120);
					pdf.text('Inicio: ' + FECHA_INICIAL + ' - Fin: ' + FECHA_FINAL, 65, 145);


					const PROPERTIES = (pdf as any).getImageProperties(velocidadesImg);
					const WIDTH = pdf.internal.pageSize.getWidth() - 2 * 15;
					const HEIGHT = (PROPERTIES.height * WIDTH) / PROPERTIES.width;
					const GRAFICAS_Y = 165

					pdf.setFontSize(14);
					pdf.setFont('sans-serif', 'bold');

					pdf.addImage(velocidadesImg, 'PNG', 15, GRAFICAS_Y, WIDTH, 350); // WIDTH, HEIGHT

					let texPosition = GRAFICAS_Y + 350 + 15
					pdf.text('Datos del Dispositivo', 90, texPosition);

					texPosition = texPosition + 15;
					pdf.setFont('sans-serif', 'normal')
					pdf.text('Vehículo:', 90, texPosition);
					pdf.text(MARCA + ', ' + MODELO, 340, texPosition);

					texPosition = texPosition + 15;
					pdf.text('Placa:', 90, texPosition);
					pdf.text(PLACA, 340, texPosition);

					texPosition = texPosition + 15;
					pdf.text('Económico:', 90, texPosition);
					pdf.text(ECONOMICO, 340, texPosition);

					texPosition = texPosition + 15;
					pdf.text('Número de Serie:', 90, texPosition);
					pdf.text(SERIE, 340, texPosition);

					texPosition = texPosition + 15;
					pdf.text('Año:', 90, texPosition);
					pdf.text(ANIO + '', 340, texPosition);

					texPosition = texPosition + 15;
					pdf.text('Color:', 90, texPosition);
					pdf.text(COLOR, 340, texPosition);

					texPosition = texPosition + 15;
					pdf.text('Descripción:', 90, texPosition);
					pdf.text(DESCRIPCION, 340, texPosition);

					texPosition = texPosition + 15;
					let listaDireccion = direccion.split(',');
					if (listaDireccion.length > 2) {
						const DIRECCION = listaDireccion[0] + ', ' + listaDireccion[1];
						let direccion2: string = ', ';

						pdf.text('Dirección:', 90, texPosition);
						pdf.text(DIRECCION, 340, texPosition);

						for (let i = 2; i < listaDireccion.length; i++) {
							direccion2 = listaDireccion[i] + direccion2;
						}

						pdf.text(direccion2, 85, texPosition + 15);

					} else {
						pdf.text('Dirección:', 90, texPosition);
						pdf.text(direccion, 340, texPosition);
					}


					pdf.setFontSize(12);
					pdf.setFont('sans-serif', 'bold');
					pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
					pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
					pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, soporte.star@growtec.com.mx', 65, 825);


					const nombreArchivo = 'Información_Estadística'
					pdf.save(nombreArchivo + '.pdf');
					this.loadingVisible = false;



				}
			);
		}, 1);

	}


	validarInfo(valor) {
		let val = 'Sin Datos'

		if (valor) {
			val = valor;
		}

		return val;
	}

}
